import React from "react";

const Category2 = ({
  categories,
  setCategories,
  handleNext,
  allCategories,
  isSmallScreen,
}) => {
  const category = ["Ready to Wear", "Unstitched", "Western Wear"];

  const handleSubmitCategories = (e) => {
    e.preventDefault();
    handleNext();
  };
  //Check if both objects are equal
  const areObjectsEqual = (subCategory1, subCategory2) => {
    return (
      Object.keys(subCategory1).length === Object.keys(subCategory2).length &&
      Object.keys(subCategory1).every(
        (key) => subCategory1[key] === subCategory2[key]
      )
    );
  };
  const handleCategoryClick = (subCategory) => {
    // console.log(select);
    // Check if the category is already added
    const isAlreadyAdded = categories.some((item) =>
      areObjectsEqual(item, subCategory)
    );
    //If added then remove
    if (isAlreadyAdded) {
      setCategories((prevCategory) =>
        prevCategory.filter((item) => !areObjectsEqual(item, subCategory))
      );
    } else {
      setCategories((prevCategory) => [...prevCategory, subCategory]);
    }
  };
  const categoryData = () => {
    return (
      <ul
        className={`list-inline d-flex flex-row flex-wrap gap-3 mt-2 mb-1 hiddenScrollbar w-100`}
      >
        {allCategories?.map((item, index) => {
          return (
            <li
              key={index}
              className={`rounded-2 hoverClass`}
              onClick={() => handleCategoryClick(item)}
            >
              <div
                className="d-flex flex-column align-items-center text-center"
                style={{ cursor: "pointer" }}
              >
                <div className="position-relative">
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 21,
                      right: "0.2rem",
                    }}
                  >
                    {categories.some((element) =>
                      areObjectsEqual(element, item)
                    ) && (
                      <i className="bi bi-check-circle-fill text-primary fs-5"></i>
                    )}
                  </div>
                  <img
                    style={{
                      zIndex: "20",
                      height: isSmallScreen ? "7rem" : "10rem",
                      objectFit: "cover",
                    }}
                    width={isSmallScreen ? "78rem" : "116rem"}
                    className="rounded-2 position-relative"
                    src={item?.imageUrl}
                    alt={item?.subSubCategoryDisplayName}
                    loading="lazy"
                  />
                </div>
                <div
                  className="nav-item text-wrap mt-2 h6 fw-light"
                  style={{
                    width: "5rem",
                    fontSize: isSmallScreen ? "0.8rem" : "0.85rem",
                    wordWrap: "break-word",
                  }}
                >
                  {item.subSubCategoryDisplayName}
                  {item.subCategory === "Unstitched" && " (Unstitched)"}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      <div
        className="text-center mb-4"
        style={{
          lineHeight: "0.5rem",
          paddingRight: isSmallScreen ? "2rem" : "4rem",
        }}
      >
        <h3
          style={{
            fontFamily: "Playfair Display",
            fontWeight: 600,
            fontSize: isSmallScreen ? "1.7rem" : "2rem",
          }}
        >
          What type of clothes you are interested in?
          {/* What are your Favourite Categories? */}
        </h3>
        <p
          className={isSmallScreen ? "px-2" : "px-5"}
          style={{
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: isSmallScreen ? "0.9rem" : "1.1rem",
            lineHeight: "1.5rem",
          }}
        >
          Select the types of clothing you love the most. This helps us
          recommend styles that match your vibe.
        </p>
      </div>
      <form onSubmit={(e) => handleSubmitCategories(e)}>
        <div
          style={{
            maxHeight: isSmallScreen ? "17rem" : "20.5rem",
            overflowY: "auto",
          }}
        >
          {categoryData()}
        </div>
        <div
          className="d-grid mt-2"
          style={{ paddingRight: isSmallScreen ? "2rem" : "4rem" }}
        >
          <button
            type="submit"
            className="btn btn-primary flex-grow-1 rounded-3"
            disabled={categories.length < 5}
          >
            {categories.length < 5
              ? `Select atleast ${5 - categories.length} ${
                  categories.length !== 0 ? " more " : ""
                }`
              : "Next"}
          </button>
        </div>
      </form>
    </>
  );
};

export default Category2;
